module.exports = __webpack_public_path__ + "static/media/cdb4.5440a96e.png";